// import DiffMatchPatch2 from './diff-match-patch.js';
const DiffMatchPatch = require('./diff-match-patch');
const { DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL, diff_match_patch } =
  DiffMatchPatch;

// 定义 Diff 类型
type Diff = [number, string];

interface ChangeObject<T> {
  count: number;
  added: boolean;
  removed: boolean;
  value: T;
}

/**
 * 将 diff_match_patch.Diff[] 转换为指定格式的差异对象数组
 * @param diffs diff_match_patch 生成的差异数组
 * @returns 转换后的差异对象数组
 */
function convertDiffs(diffs: Diff[]): ChangeObject<string>[] {
  const result: ChangeObject<string>[] = [];

  for (const diff of diffs) {
    const operation = diff[0];
    const text = diff[1];

    // 计算行数（按换行符分割）
    const lines = text.split('\n');
    const count = lines.length - 1;

    // 根据操作类型设置 added 和 removed 标志
    let added = false;
    let removed = false;

    switch (operation) {
      case DIFF_DELETE:
        removed = true;
        break;
      case DIFF_INSERT:
        added = true;
        break;
      case DIFF_EQUAL:
      default:
        // 既不是新增也不是删除
        break;
    }

    result.push({
      count,
      added,
      removed,
      value: text,
    });
  }

  return result;
}

class MarkdownDiffer {
  dmp;
  constructor() {
    this.dmp = new DiffMatchPatch();
  }
  diffLines(
    text1: string,
    text2: string,
    editCost = 1
  ): ChangeObject<string>[] {
    const diffs = this.dmp.diff_lineMode(text1, text2, editCost);
    return convertDiffs(diffs);
  }
  matchLoc(text: string, pattern: string): number {
    const loc = this.dmp.match_main(text, pattern, 0);
    return loc;
  }
}

export {
  convertDiffs,
  type ChangeObject,
  type Diff,
  DIFF_DELETE,
  DIFF_INSERT,
  DIFF_EQUAL,
  diff_match_patch,
};
export default MarkdownDiffer;
